import styled, { css } from 'styled-components';
import { TableVariant } from '../types';
export const HeaderRow = styled.tr `
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 1;
  border-bottom: 1px solid ${({ theme }) => theme.secondary.blendToBackground(200)};

  ${({ $variant }) => $variant === TableVariant.Grid &&
    css `
      background-color: ${({ theme }) => theme.secondary.blendToBackground(25)};
    `}
`;
//# sourceMappingURL=HeaderRow.js.map